/** TanStack Query key of the current session (GET /auth/me). */
export const SESSION_QUERY_KEY = ['auth', 'me'] as const
